import React from 'react';
import { Button, Col, Row, Switch } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import cloneDeep from 'lodash/cloneDeep';
import styles from './index.less';
import HourSelector from '@/components/Filters/HourSelector';

const OpenHours = ({data, onChange, supportMultipleEntries = false}) => {
  const handleSwitch = (index, checked) => {
    const newData = cloneDeep(data);
    newData[index].enabled = checked;
    if (!checked)
      return onChange(newData);

    const hasFilledSlots = newData[index].slots?.some(s => s.start && s.end);

    if (!hasFilledSlots) {
      // Find closest enabled day to prefill
      let slotsToUse = null;
      for (let i = 1; i < 7; i++) {
        const prevIndex = (index - i + 7) % 7;
        const nextIndex = (index + i) % 7;

        if (data[prevIndex].enabled && data[prevIndex].slots?.some(s => s.start && s.end)) {
          slotsToUse = cloneDeep(data[prevIndex].slots);
          break;
        }
        if (data[nextIndex].enabled && data[nextIndex].slots?.some(s => s.start && s.end)) {
          slotsToUse = cloneDeep(data[nextIndex].slots);
          break;
        }
      }

      if (slotsToUse) {
        if (!supportMultipleEntries && slotsToUse.length > 1) {
          newData[index].slots = [slotsToUse[0]];
        } else {
          newData[index].slots = slotsToUse;
        }
      } else {
        const slot = { start: null, end: null };
        if (newData[index].slots.length === 0)
          newData[index].slots.push(slot);
        else if (newData[index].slots.length === 1 && !supportMultipleEntries)
          newData[index].slots[0] = slot;
      }
    }

    onChange(newData);
  };

  const handleTimeChange = (dayIndex, slotIndex, field, time) => {
    const newData = cloneDeep(data);
    newData[dayIndex].slots[slotIndex][field] = time;
    onChange(newData);
  };

  const handleAddSlot = (dayIndex) => {
    const newData = cloneDeep(data);
    const day = newData[dayIndex];
    const newSlot = { start: null, end: null };
    day.slots.push(newSlot);
    onChange(newData);
  };

  const handleRemoveSlot = (dayIndex, slotIndex) => {
    const newData = cloneDeep(data);
    newData[dayIndex].slots.splice(slotIndex, 1);
    if (newData[dayIndex].slots.length === 0) {
        newData[dayIndex].enabled = false;
    }
    onChange(newData);
  };

  return (
    <div className={styles.branchServiceOpenHoursContainer} style={{padding: "2px"}}>
      {data.map((day, dayIndex) => (
        <div key={day.day} className={styles.branchServiceOpenHoursDayContainer}>
          <Row align="middle" justify="space-between">
            <Col span={6}><strong>{day.title}</strong></Col>
            <Col span={14}>
              {day.enabled && (
                <div className={styles.branchServiceDayRow}>
                  {day.slots.map((slot, slotIndex) => {
                    const otherSlots = day.slots.filter((_, i) => i !== slotIndex && _.start && _.end);
                    const nextSlot = otherSlots
                      .filter(s => s.start > slot.start)
                      .sort((a, b) => a.start.localeCompare(b.start))[0];
                    const prevSlot = otherSlots
                      .filter(s => s.end < slot.end)
                      .sort((a, b) => b.end.localeCompare(a.end))[0];

                    return (
                      <div
                        key={slotIndex}
                        className={styles.branchServiceOpenHoursDaySlots}
                      >
                        <div className={styles.openHourDayPickerContainer}>
                          <HourSelector
                            from={prevSlot?.end}
                            fromInclusive={true}
                            to={slot.end}
                            toInclusive={true}
                            value={slot.start}
                            excludeRanges={otherSlots}
                            onChange={(value) =>
                              handleTimeChange(
                                dayIndex,
                                slotIndex,
                                'start',
                                value,
                              )
                            }
                          />
                          <div>→</div>
                          <HourSelector
                            from={slot.start}
                            fromInclusive={true}
                            to={nextSlot?.start}
                            toInclusive={true}
                            value={slot.end}
                            onChange={(value) =>
                              handleTimeChange(
                                dayIndex,
                                slotIndex,
                                'end',
                                value,
                              )
                            }
                          />
                          {supportMultipleEntries && day.slots.length > 1 && (
                            <Button
                              type="text"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() =>
                                handleRemoveSlot(dayIndex, slotIndex)
                              }
                              size="small"
                            />
                          )}
                          {supportMultipleEntries &&
                            slotIndex === day.slots.length - 1 && (
                              <div className={styles.addSlotAction}>
                                <Button
                                  type="dashed"
                                  icon={<PlusOutlined />}
                                  onClick={() => handleAddSlot(dayIndex)}
                                  size="small"
                                ></Button>
                              </div>
                            )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </Col>
            <Col span={4} style={{textAlign: "right"}}>
              <Switch
                size={"small"}
                checked={day.enabled}
                onChange={checked => handleSwitch(dayIndex, checked)}
              />
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default OpenHours;
